export default __webpack_public_path__ + "static/main5-905d362c6071e145c1eb4fa0bb12767b.jpg";